<section>
    <!-- banner slide -->
    <div class="str_banner bg1">
        <div class="layer">
            <div class="container">
                <div class="banner_text_sec">
                    <div class="d-flex">
                        <h1>welcome</h1>
                    </div>
                    <div id="text" class="banner_text_strivels my-md-5 my-3">{{currentText}}<span aria-hidden="true" class="banner_text_strivels"></span></div>
                    <ul class="list-inline bnr_list_strive">
                        <li class="list-inline-item">
                            <a class="btn text-white scroll" [routerLink]= "['/portfolio']">view my work </a>
                        </li>
                        <li class="list-inline-item">
                            <a class="btn text-white bg-dark scroll" [routerLink]= "['/contact']">contact me</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>